import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Theme } from '@models/theme';
import { parseId } from '@rx/parse-id';
import { ThemeService } from '@services/theme.service';

@Component({
  selector: 'vnm-theme-details',
  templateUrl: './theme-details.component.html',
  styleUrls: ['./theme-details.component.scss']
})
export class ThemeDetailsComponent implements OnInit {
  theme: Theme;
  themeProperties: string[];

  constructor(private route: ActivatedRoute, private themeService: ThemeService) {}

  ngOnInit() {
    this.route.params.pipe(parseId()).subscribe((id) => {
      this.theme = this.themeService.getTheme(id);
      this.themeProperties = Object.keys(this.theme.properties);
    });
  }

  isActiveTheme() {
    return this.themeService.activeTheme.id === this.theme.id;
  }

  applyTheme() {
    this.themeService.setTheme(this.theme);
  }

  saveTheme() {
    this.themeService.updateTheme(this.theme.id, this.theme.properties);
  }
}
